<div class="cell">
  <arm-form-title>Match</arm-form-title>
  <div class="cell-content">

    <div class="source" *ngIf="isValueExists(item.nodes);">
      <div class="sub-title">Source Nodes:</div>
      <div class="sub-item">
                <span *ngFor="let node of item.nodes; let last = last;">
                    <span title="{{node.name}}">&nbsp;{{node.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
      </div>
    </div>

    <div class="source" *ngIf="isValueExists(item.PCons)">
      <div class="sub-title">Source Peer Connections:</div>
      <div class="sub-item">
                <span *ngFor="let pCon of item.PCons; let last = last;">
                    <span title="{{pCon.name}} ({{pCon.nodeName}})">&nbsp;{{pCon.name}} ({{pCon.nodeName}})&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
      </div>
    </div>

    <div class="source" *ngIf="isValueExists(item.reroutePCons)">
      <div class="sub-title">Reroute Peer Connections:</div>
      <div class="sub-item">
                <span *ngFor="let pCon of item.reroutePCons; let last = last;">
                    <span title="{{pCon.name}} ({{pCon.nodeName}})">&nbsp;{{pCon.name}} ({{pCon.nodeName}})&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
      </div>
    </div>

    <div class="source" *ngIf="isValueExists(item.topologyGroups)">
      <div class="sub-title">Source Resource Groups:</div>
      <div class="sub-item">
                <span *ngFor="let topologyGroup of item.topologyGroups; let last = last;">
                    <span title="{{topologyGroup.name}}">&nbsp;{{topologyGroup.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
      </div>
    </div>

    <div class="source" *ngIf="isValueExists(item.srcUserGroups)">
      <div class="sub-title">Source User Groups:</div>
      <div class="sub-item">
                <span *ngFor="let userGroup of item.srcUserGroups; let last = last;">
                    <span title="{{userGroup.name}}">&nbsp;{{userGroup.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
      </div>
    </div>

    <div class="source" *ngIf="isValueExists(item.dstUserGroups)">
      <div class="sub-title">Destination User Groups:</div>
      <div class="sub-item">
                <span *ngFor="let userGroup of item.dstUserGroups; let last = last;">
                    <span title="{{userGroup.name}}">&nbsp;{{userGroup.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
      </div>
    </div>

    <div class="source" *ngIf="isValueExists(item.srcAttributeGroupNames)">
      <div class="sub-title">Source Prefix Groups:</div>
      <div class="sub-item">
                <span *ngFor="let prefixGroup of item.srcAttributeGroupNames; let last = last;">
                    <span title="{{prefixGroup.name}}">&nbsp;{{prefixGroup.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
      </div>
    </div>

    <div class="source" *ngIf="isValueExists(item.attributeGroupNames)">
      <div class="sub-title">Destination Prefix Groups:</div>
      <div class="sub-item">
                <span *ngFor="let prefixGroup of item.attributeGroupNames; let last = last;">
                    <span title="{{prefixGroup.name}}">&nbsp;{{prefixGroup.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
      </div>
    </div>

    <div class="source" *ngIf="isValueExists(item.srcAttributeValues)">
      <div class="sub-title">Source Prefix Attributes:</div>
      <div class="sub-item">
                <span *ngFor="let prefix of item.srcAttributeValues; let last = last;">
                    <span title="{{prefix.value}}">&nbsp;{{prefix.value}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
      </div>
    </div>

    <div class="source" *ngIf="isValueExists(item.attributeValues)">
      <div class="sub-title">Destination Prefix Attributes:</div>
      <div class="sub-item">
                <span *ngFor="let prefix of item.attributeValues; let last = last;">
                    <span title="{{prefix.value}}">&nbsp;{{prefix.value}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
      </div>
    </div>

      <div class="source" *ngIf="item.sipConditionGroup">
          <div class="sub-title">SIP Condition Group:</div>
          <div class="sub-item">
              <span title="{{item.sipConditionGroup.name}}">&nbsp;{{item.sipConditionGroup.name}}</span>
          </div>
      </div>

    <div *ngIf="isValueExists(item.searchBy)">
      <div class="source" *ngFor="let item of item.searchBy">
        <div class="sub-title">{{item.name | titlecase}}:</div>
        <div class="sub-item">
            <span *ngFor="let value of item.values; let last = last;" title="{{value.name}}">&nbsp;{{value.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
        </div>
      </div>
    </div>

      <div *ngIf="isValueExists(item.sipHeadersInfo)" class="section-container">
          <div class="section-title">Sip Headers</div>
          <div class="sip-header details-section source" *ngFor="let sipHeader of item.sipHeadersInfo">
              <div class="sub-title">{{sipHeader.name}}:</div>
              <div class="sub-item">
                <span *ngFor="let value of sipHeader.value; let last = last;">
                    <span title="{{value}}">&nbsp;{{value}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
              </div>
          </div>
      </div>
  </div>
</div>
